import Loader from '@/components/Loader';
import { LanguageType } from '@/models/LanguageType';
import { ImportHistory as IImportHistory } from '@/models/Person';
import { momentWithTimeZone } from '@/services/UtilService';
import { ApplicationState } from '@/store';
import { getImportHistoryRequest } from '@/store/person/action';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from './Modal';
import './style.scss';

const ImportHistory = () => {
    const [selectedItem, setSelectedItem] = useState<undefined | IImportHistory>(undefined);
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);
    const {
        data: { importHistory },
        loading,
    } = useSelector((state: ApplicationState) => state.people);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getImportHistoryRequest({ limit: 100, offset: 0 }));
    }, [dispatch, getImportHistoryRequest]);

    return (
        <>
            <Modal
                id={selectedItem ? selectedItem.id : undefined}
                personId={selectedItem ? selectedItem.personId : undefined}
                status={selectedItem ? selectedItem.status : undefined}
                target={`alert-modal-import-history-${selectedItem ? selectedItem.id : ''}`}
            />
            <div className="import-table">
                {loading && <Loader />}
                {!loading && importHistory && importHistory.length > 0 && (
                    <table className="table table-borderless table-sm table-striped">
                        <thead>
                            <tr>
                                <th scope="col">ID</th>
                                <th scope="col">{strings.DATE}</th>
                                <th scope="col">{strings.TOTAL_RECORDS}</th>
                                <th scope="col">{strings.TOTAL_PROCESSED}</th>
                                <th scope="col">{strings.STATUS}</th>
                                <th scope="col">{strings.DETAILS}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {importHistory.map((ih: IImportHistory) => (
                                <tr className="table-row" key={ih.id}>
                                    <td scope="row">{ih.id}</td>
                                    <td>{momentWithTimeZone(ih.timestamp, strings._LANGUAGE as LanguageType)}</td>
                                    <td>{ih.totalNumberOfPeople}</td>
                                    <td>{ih.completedItems}</td>
                                    <td>{strings[ih.status]}</td>
                                    <td>
                                        <button
                                            className="btn btn-primary btn-sm"
                                            data-target={`#alert-modal-import-history-${selectedItem ? selectedItem.id : ''}`}
                                            data-toggle="modal"
                                            onClick={() => setSelectedItem(ih)}
                                        >
                                            {strings.SEE}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
                {!loading && importHistory && importHistory.length <= 0 && <p className="emptySection">{strings.EMPTY_IMPORT_HISTORY}</p>}
            </div>
        </>
    );
};

export default ImportHistory;
